// In every file you need this!

// import $ from 'jquery';
// //attach jquery to dom
// window.jQuery = $;
// window.$ = $;

import 'owl.carousel';


(function($) {
	$( document ).ready(function() {

		if ($(".products_carousel")[0]) {
			$(document).ready(function() {
				var carousel = $(".products_carousel .owl-carousel");
				carousel.owlCarousel({
				  loop: true,
				  nav: true,
				  responsiveClass: true,
				  responsive: {
				    0: {
				    	items: 1
				    },
				    992: {
				    	items: 2
				    },
				    1025: {
				    	items: 4
				    }
				  }
				});
			});

			$(".owl_nav_products_carousel").on("click", function() {
				if ($(this).hasClass("prev")) {
					$(".products_carousel button.owl-prev").trigger("click");
				} else if ($(this).hasClass("next")) {
					$(".products_carousel button.owl-next").trigger("click");
				}
			});
		}


		if ($(".services_carousel")[0]) {
			$(document).ready(function() {
				var carousel = $(".services_carousel .owl-carousel");
				carousel.owlCarousel({
				  loop: true,
				  nav: true,
				  responsiveClass: true,
				  responsive: {
				    0: {
				    	items: 1
				    },
				    992: {
				    	items: 2
				    },
				    1025: {
				    	items: 4
				    }
				  }
				});
			});

			$(".owl_nav_services_carousel").on("click", function() {
				if ($(this).hasClass("prev")) {
					$(".services_carousel button.owl-prev").trigger("click");
				} else if ($(this).hasClass("next")) {
					$(".services_carousel button.owl-next").trigger("click");
				}
			});
		}

		if ($(".comapnies_carousel")[0]) {
			$(document).ready(function() {
				var carousel = $(".comapnies_carousel .owl-carousel");
				carousel.owlCarousel({
				  loop: true,
				  nav: true,
				  autoplay: true,
				  responsiveClass: true, 
				  responsive: {
				    0: {
				    	items: 1
				    },
				    992: {
				    	items: 2
				    },
				    1025: {
				    	items: 4
				    }
				  }
				});
			});

			$(".owl_nav_services_carousel").on("click", function() {
				if ($(this).hasClass("prev")) {
					$(".comapnies_carousel button.owl-prev").trigger("click");
				} else if ($(this).hasClass("next")) {
					$(".comapnies_carousel button.owl-next").trigger("click");
				}
			});
		}

	});
})(jQuery);